import React from "react";

export default function HpAgreementView({ data, preview_url }) {
  if (!data) {
    return (
      <div className="p-4 text-red-500">
        No HP Agreement data available
      </div>
    );
  }

  const parties = data.parties || {};
  const agreementInfo = data.agreement_info || {};
  const asset = data.asset || {};
  const financialTerms = data.financial_terms || {};
  const additionalInfo = data.additional_info || {};
  const schedules = data.payment_schedules || [];

  return (
    <>
      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3]  rounded-t-lg">
        <h2 className="text-lg font-semibold">HP Agreement</h2>
      </div>

      {/* Hirer & Lessor + Agreement & Asset */}
      <div className="border border-t-0 rounded-b-lg p-6 grid grid-cols-2 gap-6 bg-white shadow">
        {/* Hirer & Lessor */}
        <div>
          <h3 className="font-semibold mb-2">Hirer & Lessor</h3>
          <hr className="mb-3" />

          <div className="grid grid-cols-2 gap-y-2 text-sm">
            <span className="font-semibold">Hirer</span>
            <span>{parties.hirer?.name || "-"}</span>

            <span className="font-semibold">Hirer Address</span>
            <span>
              {[ 
                parties.hirer?.address?.line1,
                parties.hirer?.address?.line2,
                parties.hirer?.address?.city
              ].filter(Boolean).join(", ") || "-"}
            </span>

            <span className="font-semibold">Hirer Contact</span>
            <span>
              {parties.hirer?.contact?.phone ||
                parties.hirer?.contact?.email ||
                "-"}
            </span>

            <span className="font-semibold">Hirer Company Reg</span>
            <span>{parties.hirer?.companyRegistrationNumber || "-"}</span>

            <span className="font-semibold">Lessor</span>
            <span>{parties.lessor?.name || "-"}</span>

            <span className="font-semibold">Lessor Address</span>
            <span>
              {[
                parties.lessor?.address?.line1,
                parties.lessor?.address?.line2,
                parties.lessor?.address?.city
              ].filter(Boolean).join(", ") || "-"}
            </span>

            <span className="font-semibold">Lessor Contact</span>
            <span>
              {parties.lessor?.contact?.phone ||
                parties.lessor?.contact?.email ||
                "-"}
            </span>

            <span className="font-semibold">Lessor Company Reg</span>
            <span>{parties.lessor?.companyRegistrationNumber || "-"}</span>
          </div>
        </div>

        {/* Agreement & Asset */}
        <div>
          <h3 className="font-semibold mb-2">Agreement & Asset</h3>
          <hr className="mb-3" />

          <div className="grid grid-cols-2 gap-y-2 text-sm">
            <span className="font-semibold">Agreement #</span>
            <span>{agreementInfo.agreementNumber || "-"}</span>

            <span className="font-semibold">Type</span>
            <span>{agreementInfo.agreementType || "-"}</span>

            <span className="font-semibold">Agreement Date</span>
            <span>{agreementInfo.agreementDate || "-"}</span>

            <span className="font-semibold">Commencement</span>
            <span>{agreementInfo.commencementDate || "-"}</span>

            <span className="font-semibold">Expiry</span>
            <span>{agreementInfo.expiryDate || "-"}</span>

            <span className="font-semibold">Status</span>
            <span>{agreementInfo.agreementStatus || "-"}</span>

            <span className="font-semibold">Asset</span>
            <span>{asset.description || "-"}</span>

            <span className="font-semibold">Make/Model</span>
            <span>{asset.makeModel || "-"}</span>

            <span className="font-semibold">Serial #</span>
            <span>{asset.serialNumber || "-"}</span>

            <span className="font-semibold">Reg #</span>
            <span>{asset.registrationNumber || "-"}</span>

            <span className="font-semibold">Year</span>
            <span>{asset.yearOfManufacture || "-"}</span>

            <span className="font-semibold">Condition</span>
            <span>{asset.condition || "-"}</span>
          </div>
        </div>
      </div>

      {/* Financial Terms */}
      <div
        className="mt-4 p-6 border rounded-lg bg-white flex justify-between"
        style={{ fontSize: ".875rem" }}
      >
        <div>
          <p><b>Purchase Price:</b> {asset.purchasePrice || "-"}</p>
          <p><b>Down Payment:</b> {financialTerms.downPayment || "-"}</p>
          <p><b>Interest Rate:</b> {financialTerms.interestRate || "-"}</p>
          <p><b>Final Payment:</b> {financialTerms.finalPayment || "-"}</p>
          <p><b>Currency:</b> {financialTerms.currency || "-"}</p>
          <p>
            <b>Insurance Required:</b>{" "}
            {additionalInfo.insuranceRequired ? "Yes" : "No"}
          </p>
        </div>

        <div>
          <p><b>Current Value:</b> {financialTerms.totalAmountFinanced || "-"}</p>
          <p><b>Monthly Payment:</b> {financialTerms.monthlyPayment || "-"}</p>
          <p><b>APR:</b> {financialTerms.apr || "-"}</p>
          <p><b>Processing Fees:</b> {financialTerms.processingFees || "-"}</p>
        </div>

        <div>
          <p>
            <b>Total Amount Financed:</b>{" "}
            {financialTerms.totalAmountFinanced || "-"}
          </p>
          <p><b>Payment Frequency:</b> {financialTerms.paymentFrequency || "-"}</p>
          <p><b>Total Amount Payable:</b> {financialTerms.totalAmountPayable || "-"}</p>
          <p><b>Admin Charges:</b> {financialTerms.adminCharges || "-"}</p>
          <p>
            <b>Option to Purchase:</b>{" "}
            {additionalInfo.optionToPurchase ? "Yes" : "No"}
          </p>
        </div>
      </div>

      {/* PDF Preview */}
      {preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">
            Uploaded Document Preview
          </h3>
          <iframe
            src={preview_url}
            width="100%"
            height="600"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title="PDF Preview"
          />
        </div>
      )}
    </>
  );
}
